var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2185 12.483C11.0298 12.6716 10.7967 12.8157 10.544 12.8999L8.1035 13.7134C7.92736 13.7721 7.74368 13.802 7.55784 13.802C7.09686 13.802 6.66349 13.6225 6.33757 13.2965C5.87237 12.8312 5.71269 12.1546 5.92073 11.5305L6.73424 9.09015C6.81842 8.8374 6.96261 8.60409 7.15109 8.41561L12.4222 3.14453H2.10914C0.946159 3.14453 0 4.09069 0 5.25367V17.525C0 18.688 0.946159 19.6341 2.10914 19.6341H14.3805C15.5435 19.6341 16.4896 18.688 16.4896 17.525V7.21194L11.2185 12.483Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.96441 9.22909C7.90125 9.29225 7.8537 9.36921 7.82548 9.45392L7.01196 11.8943C6.94305 12.101 6.99685 12.3289 7.1509 12.483C7.30498 12.6371 7.53284 12.6909 7.73954 12.6219L10.18 11.8084C10.2648 11.7802 10.3417 11.7327 10.4048 11.6695L17.5906 4.48376L15.1502 2.04333L7.96441 9.22909Z",
    fill: "#FCFCFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2687 0.280793C17.8943 -0.0935977 17.2873 -0.0935977 16.9129 0.280793L15.9639 1.22987L18.4043 3.67033L19.3534 2.72126C19.7278 2.34687 19.7278 1.73986 19.3534 1.36546L18.2687 0.280793Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.30cb233b451dd5b1ef731f28952cf4cc.svg";
export { ForwardRef as ReactComponent };